import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { LangService } from 'src/app/common/service/lang.service';
import { createPassengerReportFilename, generateReportTitle } from 'src/app/reports/util/bus-stop-report-util';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { SortBy } from 'src/app/shared/model/data-source';
import { ExportRequest } from 'src/app/shared/model/export-request';
import { FileType } from 'src/app/shared/model/file-type';
import { createTitlesAsString, createViewStateAsString } from 'src/app/shared/util/view-state-creator';
import { FileTable } from '../../files/model/file-table';
import { RequestCriteria } from '../../shared/model/request-criteria';
import { RestSimpleRequest } from '../../shared/model/rest-simple-request';
import { RestService } from '../../shared/service/rest.service';
import { FileContent, ReportFileRequestParams } from '../model/report-file-request-params';

@Injectable()
export class BusStopReportFilePreparatorService extends RestService {

  constructor(private translate: TranslateService, private langService: LangService, protected http: HttpClient, public settings: UserSettingsService) {
    super(http);
  }

  sendCreateReportRequest(exportRequest: ExportRequest, filters: RequestCriteria, visibleColumnNames: string[], sortBy: SortBy[], groupBy: string,
    correctedReportsDataType: boolean, fromArchive: boolean): Observable<any> {
    const reportName = this.settings.getBusStopReportNameOptionSetting();
    const reportTitle = generateReportTitle(filters, this.translate.instant(reportName), this.translate);
    const fileName = exportRequest.fileName || createPassengerReportFilename(reportName, correctedReportsDataType, filters, this.translate);
    const titles = createTitlesAsString(visibleColumnNames, this.translate);
    const viewState = createViewStateAsString(sortBy, visibleColumnNames, groupBy);

    const params: ReportFileRequestParams = {
      viewState,
      reportTitle,
      titles,
      file_type: exportRequest.fileType,
      filename: fileName,
      summaries: '{}',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Accept-Language': this.langService.getLanguage(),
      cron: exportRequest.cron,
      archive: fromArchive ?? false
    };

    const request: RestSimpleRequest<RequestCriteria> = { params, data: filters };
    return this.doPost<void>(`api/async/files/criteria/generate?archive=${fromArchive}`, request);
  }

  sendCreatePunctualityReportRequest(request: PassengerCountRequest): Observable<FileContent> {
    const name = this.translate.instant(request.fileTable);
    const payload = {
      params: {
        fileTable: request.fileTable,
        file_type: request.file_type,
        filename: request.fileName || name + '-' + moment(new Date()).toVisibleDateTimeFormat() + '-' + request.file_type,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Accept-Language': this.langService.getLanguage(),
        cron: null,
        start: request.start,
        end: request.end
      }
    };
    return this.postAndExtractSingle(FileContent, 'api/files/passengers/criteria/generate', payload);
  }

}

export class PassengerCountRequest {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  constructor(public readonly file_type: FileType, public readonly fileTable: FileTable, public readonly start: Date,
    public readonly end: Date, public fileName: string) { }
}
